















import { Vue, Component } from 'vue-property-decorator'
interface route {
  title: string
  to: string
}
@Component({
  name: 'MyApproval'
})
export default class extends Vue {
  showNav = true
  routeList: route[] = [
    {
      title: '看板',
      to: '/payment/payment-manage/payment-board'
    },
    // {
    //   title: '通道配置',
    //   to: '/payment/payment-manage/passageway-config'
    // },
    {
      title: '流水查询',
      to: '/payment/payment-manage/statement-query'
    },
    {
      title: '支付账号',
      to: '/payment/payment-manage/payment-account'
    },
    {
      title: '接入模块',
      to: '/payment/payment-manage/access-module'
    }
  ]
}
